import { computed } from 'vue'
import { useRoute } from 'vue-router'

/** Zentralisiertes Lesen von category/product IDs aus Route-Query-Params */
export function useRouteQueryIds() {
  const route = useRoute()

  function qStr(...keys: string[]): string | null {
    for (const key of keys) {
      const v = route.query[key]
      if (v == null) continue
      const s = String(Array.isArray(v) ? v[0] : v).trim()
      if (s) return s
    }
    return null
  }

  function qNum(...keys: string[]): number | null {
    const s = qStr(...keys)
    if (s == null) return null
    const n = Number(s)
    return Number.isFinite(n) && n > 0 ? n : null
  }

  const categoryId = computed<number | null>(() => qNum('category', 'categoryId'))
  const productId = computed<number | null>(() => qNum('product', 'productId'))

  const categoryIri = computed<string | null>(() =>
    categoryId.value ? `/api/categories/${categoryId.value}` : null
  )
  const productIri = computed<string | null>(() =>
    productId.value ? `/api/products/${productId.value}` : null
  )

  return { categoryId, productId, categoryIri, productIri }
}
